import { render } from "./PdfList.vue?vue&type=template&id=2fd40b04&scoped=true"
import script from "./PdfList.vue?vue&type=script&lang=js"
export * from "./PdfList.vue?vue&type=script&lang=js"

import "./PdfList.vue?vue&type=style&index=0&id=2fd40b04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd40b04"]])

export default __exports__